import React, { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

interface RulesLottieProps {
  className?: string;
}

export default function RulesLottie({ className = '' }: RulesLottieProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const lottieRef = useRef<DotLottie | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      lottieRef.current = new DotLottie({
        autoplay: true,
        loop: true,
        canvas: canvasRef.current,
        src: 'https://lottie.host/d7113074-24d6-49cf-ae60-d68beb6996fa/kO9npId9to.lottie'
      });
    }

    return () => {
      if (lottieRef.current) {
        lottieRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className={`relative ${className}`}>
      <canvas 
        ref={canvasRef}
        className="max-w-[300px] mx-auto"
        width="300"
        height="300"
        style={{ width: '300px', height: '300px' }}
      />
    </div>
  );
}